const CONTENT_LOAD_PLACEHOLDER = {
  BLUR: 'BLUR',
  COLOR: 'COLOR',
  MAIN_COLOR: 'MAIN_COLOR',
};

export default CONTENT_LOAD_PLACEHOLDER;
